import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

/**
 * Скрипт скролла блока "Новости" в сайдбаре на главной
 */
$(document).ready(() => {

    var news_blocks = $('.js-hh-sidebar-news');

    if (! news_blocks.length) {
        return;
    }

    new SimpleBar(news_blocks[0], {
        autoHide: false,
        scrollbarMinSize: 100,
    });
});

/**
 * Скрипт скролла постов блока "Тема" на главной
 */
jQuery(document).ready(function ($) {

    var theme_posts = $('.js-hh-theme-posts');

    if (! theme_posts.length) {
        return;
    }

    new SimpleBar(theme_posts[0], {
        autoHide: false,
        scrollbarMinSize: 100
    });
});